import { render, staticRenderFns } from "./ReferralGroupsManager.vue?vue&type=template&id=ff04c3ae&scoped=true&"
import script from "./ReferralGroupsManager.vue?vue&type=script&lang=js&"
export * from "./ReferralGroupsManager.vue?vue&type=script&lang=js&"
import style0 from "./ReferralGroupsManager.vue?vue&type=style&index=0&id=ff04c3ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff04c3ae",
  null
  
)

export default component.exports